import React, { ReactNode } from 'react';

import { TYPOGRAPHY_BODY_PARAGRAPH } from '@developer/config';

import { buildCssClassName } from '@developer/utils';

import './styles.scss';

type TypographyProps = {
  tag: string;
  children: ReactNode | string;
  variant?: string;
  classes?: string;
};

export const Typography = ({
  tag,
  children,
  variant,
  classes,
  ...rest
}: TypographyProps): JSX.Element => {
  const Tag: any = tag;

  return (
    <Tag className={buildCssClassName([classes, variant])} {...rest}>
      {children}
    </Tag>
  );
};

Typography.defaultProps = {
  classes: '',
  variant: TYPOGRAPHY_BODY_PARAGRAPH,
};
